import React, { useState } from "react";
import {
  Grid,
  Button,
  MenuItem,
  Select,
  TextField,
  Stack,
  Typography,
  CircularProgress,
  Tooltip, Checkbox
} from "@mui/material";
import CustomExpandMore from "../../../../common/CustomExpandMore";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import { useStyles } from "../styles";
import useCircular from "../../../../Hooks/circular";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../../common/Loader";
import { useEffect } from "react";
import { scrolltoView } from "../../../../Utils/scrollToView";
import DropZone from "../../../../common/DropZone";
import useCourse from "../../../../Hooks/course";
import useAuthStore from "../../../../Hooks/auth";
import { yearList } from "../../../StaffScreen/Migration/fillter";

const CircularSchema = Yup.object().shape({
  title: Yup.string().required("* Please enter title"),
});

const EditCircularManagement = () => {
  const {
    activeCircular,
    circularDate,
    updateCircularAction,
    loading,
    studentsByIdAction,
    getStudentsID,
  } = useCircular();
  const {
    getDepartmentAction,
    departmentData,
  } = useCourse();

  const { institutionId } = useAuthStore();
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [mediaURL, setMediaURL] = useState("");
  const [edit, setEdit] = useState(false);
  const [state, setState] = useState([]);
  const [idStudent, setIdStudent] = useState({ studentIDS: [] });
  const [studentName, setStudentName] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [idDepartment, setIdDepartment] = useState("");
  const [idYear, setIdYear] = useState("");
  const activeCircularIndex = circularDate?.circularList?.findIndex(
    (_el) => _el?.id === activeCircular
  );
  // console.log(
  //   "edit",
  //   circularDate[activeCircularIndex].mediaUrl.split("/").pop(),
  //   mediaURL
  // );

  const navigate = useNavigate();
  const classes = useStyles();
  useEffect(() => {
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
  }, []);

  useEffect(() => {
    // handleAddtionalInfoAction(activeCircularIndex);
    scrolltoView(`#updateCircular`);
  }, []);

  const handleChangeFile = (file) => {
    setEdit(true);
    const _file = file[0];
    setFile(_file);
    let reader = new FileReader();

    // Convert the file to base64 text
    reader.readAsDataURL(_file);
    reader.onload = () => {
      setMediaURL(reader.result.substr(reader.result.indexOf(",") + 1));
    };
  };

  // const getBase64FromUrl = async (url) => {
  //   const data = await fetch(url);
  //   const blob = await data.blob();
  //   return new Promise((resolve) => {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(blob);
  //     reader.onloadend = () => {
  //       const base64data = reader.result;
  //       resolve(base64data);
  //     };
  //   });
  // };

  React.useEffect(() => {
    setPreview(
      circularDate?.circularList[activeCircularIndex]?.mediaUrl
        ?.split(/[#?]/)[0]
        .split(".")
        .pop()
        .trim()
    );
    // getBase64FromUrl(
    //   "https://lh3.googleusercontent.com/i7cTyGnCwLIJhT1t2YpLW-zHt8ZKalgQiqfrYnZQl975-ygD_0mOXaYZMzekfKW_ydHRutDbNzeqpWoLkFR4Yx2Z2bgNj2XskKJrfw8"
    //   // circularDate?.circularList[activeCircularIndex]?.mediaUrl
    // ).then((res) => setMediaURL(res.substr(res.indexOf(",") + 1)));
    setMediaURL(circularDate?.circularList[activeCircularIndex]?.mediaUrl)
    setFile(circularDate?.circularList[activeCircularIndex]?.mediaUrl);
    setIdDepartment(circularDate?.circularList[activeCircularIndex]?.idDepartment)
    setIdYear(circularDate?.circularList[activeCircularIndex]?.currentYear)
    console.log("datas", circularDate?.circularList[activeCircularIndex])
    studentsByIdAction({
      currentYear: circularDate?.circularList[activeCircularIndex]?.currentYear,
      DepartmentID: circularDate?.circularList[activeCircularIndex]?.idDepartment,
      institutionId: institutionId
    })
  }, []);

  React.useEffect(() => {
    if (getStudentsID) {
      let studentListIDS = circularDate?.circularList[activeCircularIndex]?.idStudents.map((ele) => ({ id: ele.id }))
      setIdStudent({ studentIDS: studentListIDS })
      const commonIds = circularDate?.circularList[activeCircularIndex]?.idStudents
        ?.filter(item1 => getStudentsID?.some(item2 => item2?.id === item1?.id))
        ?.map(commonItem => {
          const correspondingItem = getStudentsID?.find(item => item?.id === commonItem?.id);
          return correspondingItem?.name;
        });
      setStudentName(commonIds)
    }
  }, [getStudentsID])

  useEffect(() => {
    if (idYear && idDepartment) {
      studentsByIdAction({
        currentYear: idYear,
        DepartmentID: idDepartment,
        institutionId: institutionId
      })
      setStudentName([]);
      setIdStudent({ studentIDS: [] });
    }
  }, [idYear, idDepartment])


  const initValues = {
    title: circularDate?.circularList[activeCircularIndex]?.title,
    description: circularDate?.circularList[activeCircularIndex]?.description,
  };

  const handleSelectStudentFocus = (event) => {
    const {
      target: { value },
    } = event;
    setState(
      // On autofill we get a stringified value.
      typeof value === "string" ? value?.split(",") : value
    );
  };

  const handleStudentSelectAll = (event) => {
    if (event.target.checked) {
      let customer_names = getStudentsID?.map((ele) => ele?.name)
      let selectCustomer_id = [];
      getStudentsID?.map((ele) => {
        selectCustomer_id?.push({ id: ele?.id })
      })
      setStudentName(customer_names)
      setIdStudent({ studentIDS: selectCustomer_id })
    }
    else {
      setStudentName([])
      setIdStudent({ studentIDS: [] })
    }
  }

  const handleSelectStudent = (event, data) => {
    if (idStudent?.studentIDS?.some((item) => item?.id == data?.id)) {
      setIdStudent({ ...idStudent, studentIDS: idStudent?.studentIDS?.filter((item) => item?.id !== data?.id) })
    } else {
      setIdStudent({ ...idStudent, studentIDS: [...idStudent?.studentIDS, { id: data?.id }] })
    }
    if (studentName?.includes(data?.name)) {
      setStudentName(studentName?.filter((item) => item !== data?.name))
    } else {
      setStudentName([...studentName, data?.name])
    }
  };


  const handleUpdateFunction = (values) => {
    const errors = {};
    if (studentName?.length === 0) {
      errors.studentName = "* Please select the student"
    }
    if (idDepartment === "") {
      errors.idDepartment = "* Please select the department"
    }
    if (idYear === "") {
      errors.idYear = "* Please select the year"
    }
    if (!values.description) {
      errors.description = "* Please enter the circular description"
    }
    if (!values.title) {
      errors.title = "* Please enter title"
    }
    setFormErrors(errors)

    if (Object.keys(errors).length === 0) {
      updateCircularAction({
        title: values.title,
        description: values.description,
        idDepartment: idDepartment,
        currentYear: idYear,
        id: activeCircular,
        fileName:
          file.name ||
          circularDate?.circularList[activeCircularIndex]?.mediaUrl?.split("/").pop(),
        contentType:
          file?.name?.split(".")[file?.name?.split(".").length - 1] ||
          circularDate?.circularList[activeCircularIndex]?.mediaUrl?.split(".").pop(),
        mediaUrl: file ? file.name === "" ? "" : mediaURL : "",
        idStudents: idStudent?.studentIDS,
        institutionId
      });
      navigate(-1);
    }
  }

  return (
    <>
      {loading && <Loader />}
      <Grid container className={classes.circularList}>
        <Grid item lg={8} sm={12}>
          <Stack className={classes.align}>
            <Formik
              validationSchema={CircularSchema}
              initialValues={initValues}
              validateOnBlur={false}
              validateOnChange={false}
              enableReinitialize
              onSubmit={(values) => {
                handleUpdateFunction(values)
              }}
            >
              {(formik) => {
                const {
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  values,
                } = formik;
                return (
                  <form onSubmit={handleSubmit}>
                    <Stack>
                      <Typography
                        id="updateCircular"
                        className={classes.title}
                        sx={{ pb: 2 }}
                      >
                        Update Circular
                      </Typography>
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Title
                      </Typography>
                      <TextField
                        id="title"
                        name="title"
                        placeholder="Enter Title"
                        className={
                          errors.title && touched.title
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        onChange={handleChange}
                        value={values.title}
                      />
                      <span className={classes.error}>
                        {formErrors.title}
                      </span>
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Circular Description
                      </Typography>
                      <TextField
                        id="description"
                        name="description"
                        placeholder="Enter Circular Description"
                        multiline
                        rows={4}
                        className={
                          errors.description && touched.description
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        type="text"
                        onChange={handleChange}
                        value={values.description}
                      />
                      <span className={classes.error}>
                        {formErrors.description}
                      </span>
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Department
                      </Typography>
                      <Select
                        id="idDepartment"
                        name="idDepartment"
                        placeholder="Choose Organization"
                        IconComponent={CustomExpandMore}
                        defaultValue="Select Department"
                        onChange={(e) => {
                          handleChange(e);
                          setIdDepartment(e.target.value);
                        }}
                        value={idDepartment}
                        displayEmpty
                        sx={{
                          "& .MuiSelect-select .notranslate::after":
                            "Select a filter"
                              ? { content: `"Select Department"`, opacity: 1 }
                              : {},
                        }}
                      >
                        <MenuItem value="" disabled>
                          Select Department
                        </MenuItem>
                        {departmentData && departmentData?.map(
                          (_el, index) => (
                            <MenuItem value={_el.id} key={index}> {_el.name}</MenuItem>
                          ))}
                      </Select>
                      <span className={classes.error}>
                        {formErrors.idDepartment}
                      </span>
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Year
                      </Typography>
                      <Select
                        id="idYear"
                        name="idYear"
                        placeholder="Choose Organization"
                        IconComponent={CustomExpandMore}
                        defaultValue="Select Year"
                        onChange={(e) => {
                          handleChange(e);
                          setIdYear(e.target.value)
                        }}
                        value={idYear}
                        displayEmpty
                        sx={{
                          "& .MuiSelect-select .notranslate::after":
                            "Select a filter"
                              ? { content: `"Select Year"`, opacity: 1 }
                              : {},
                        }}
                      >
                        <MenuItem value="" disabled>
                          Select Year
                        </MenuItem>
                        {yearList && yearList?.map((_el, index) => (
                          <MenuItem value={_el.value} key={index}> {_el.label} </MenuItem>
                        ))}
                      </Select>
                      <span className={classes.error}>
                        {formErrors.idYear}
                      </span>
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Student
                      </Typography>
                      <Select
                        disabled={values.idTarget === "" ? true : false}
                        id="studentName"
                        name="studentName"
                        multiple
                        placeholder="Choose Organization"
                        IconComponent={CustomExpandMore}
                        defaultValue="Select Student"
                        displayEmpty
                        value={studentName}
                        onFocus={handleSelectStudentFocus}
                        renderValue={(selected) => selected?.join(', ')}
                        sx={{
                          "& .MuiSelect-select .notranslate::after":
                            "Select a filter"
                              ? { content: `"Select Student"`, opacity: 1 }
                              : {},
                        }}
                      >
                        <MenuItem value="" disabled>Select Student</MenuItem>
                        {/*  */}
                        {getStudentsID?.length > 1 ?
                          <label htmlFor="studentAll">
                            <div style={{ padding: "6px 16px", cursor: "pointer" }} onChange={(event) => handleStudentSelectAll(event)}>
                              <Checkbox id="studentAll" checked={idStudent?.studentIDS?.length === getStudentsID?.length} />Select All
                            </div>
                          </label> : ""}
                        {getStudentsID &&
                          getStudentsID?.map((_el, index) => (
                            <div key={_el?.id} style={{ padding: "6px 16px", cursor: "pointer" }}
                              onClick={(event) => handleSelectStudent(event, _el)}
                            >
                              <Checkbox checked={studentName?.includes(_el?.name)} />{_el?.name}
                            </div>
                          ))}
                      </Select>
                      <span className={classes.error}>
                        {formErrors.studentName}
                      </span>
                    </Stack>
                    <DropZone handleChangeFile={handleChangeFile} />
                    <Stack sx={{ mb: 2 }}>
                      <em>
                        {edit
                          ? file.name
                          : circularDate?.circularList[activeCircularIndex]?.mediaUrl
                            ?.split("/")
                            .pop()}
                      </em>
                    </Stack>
                    <Button
                      type="submit"
                      sx={{
                        width: "100%",
                        px: 1,
                        py: 2,
                        borderRadius: "50px",
                        fontSize: "15px",
                      }}
                      className={classes.submit_btn}
                    >
                      {loading ? (
                        <CircularProgress size={22} />
                      ) : (
                        "Update Circular"
                      )}
                    </Button>
                    <Button
                      type="button"
                      sx={{
                        width: "100%",
                        px: 1,
                        py: 2,
                        borderRadius: "50px",
                        fontSize: "15px",
                        my: 2,
                      }}
                      className={classes.back_btn}
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </Button>
                  </form>
                );
              }}
            </Formik>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default EditCircularManagement;
